import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoSmall = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 20,
	viewBox: "0 0 18 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Group 1000003899",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group 1000003898",
			children: [/* @__PURE__ */ _jsx("path", {
				id: "Rectangle 1",
				d: "M0.336487 2.45956C0.336487 1.12091 1.42168 0.0357208 2.76033 0.0357208C4.09898 0.0357208 5.18417 1.12091 5.18417 2.45956V19.8745C5.18417 19.9241 5.14398 19.9643 5.0944 19.9643H2.76033C1.42168 19.9643 0.336487 18.8791 0.336487 17.5404V2.45956Z",
				fill: "#0587FB"
			}), /* @__PURE__ */ _jsx("ellipse", {
				id: "Ellipse 1",
				cx: 12.6813,
				cy: 14.9819,
				rx: 4.98234,
				ry: 4.98214,
				fill: "#0587FB"
			})]
		})
	})
});
export default SvgLogoSmall;
